<template>
  <div class="kpi-stats">
    <div class="kpi-stats__result">
      <span class="kpi-stats__result-title">{{ $t('completion') }}</span>
      <span class="kpi-stats__result-value">{{ resultPercentage }}%</span>
    </div>
    <div class="kpi-stats__diagram">
      <div
        class="kpi-stats__block kpi-stats__block--plan"
        :class="{'kpi-stats__block--empty' : plan === 0}"
        :style="{height: `${plan ? '100%' : '2px'}`, minHeight: '2px'}"
      >
        {{ `${ formatNumber ? formatDigit(plan, separatorType, minFractionDigits) : plan }${ this.percent ? '%' : '' }` }}
      </div>
      <div
        class="kpi-stats__block kpi-stats__block--fact"
        :class="{'kpi-stats__block--empty' : resultPercentage === 0}"
        :style="{height: resultPercentage ? `${resultPercentage}%` : '2px', minHeight: '2px'}"
      >
        <span class="kpi-stats__block kpi-stats__block--fact__value">
          {{ `${ formatNumber ? formatDigit(fact, separatorType, minFractionDigits) : fact }${ this.percent ? '%' : '' }`}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import formatDigit from "@prospace/prospace-components-library/src/lib-assets/mixins/digitFormatter";

export default {
  name: "AddressProgramKpiStats",
  props: {
    planProp: {
      type: Number
    },
    factProp: {
      type: Number
    },
    percent:{
      type: Boolean,
      default: false
    },
    formatNumber: {
      type: Boolean,
      default: true
    },
    minFractionDigits: {
      type: Number,
      default: 2
    },
    separatorType: {
      // separator for float
      type: String,
      default: ''
    },
    useRawValues: {
      type: Boolean,
      default: false
    },
    revertKPI: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    planProp: {
      handler(val) {
        let result = val || 0
        if (val && this.percent) {
          result *= 100
        }
        this.plan = result;
      },
      immediate: true,
    },
    factProp: {
      handler(val) {
        let result = val || 0
        if (val && this.percent) {
          result *= 100
        }
        this.fact = result
      },
      immediate: true,
    },
  },
  data() {
    return {
      plan: 0,
      fact: 0
    }
  },
  computed: {
    resultPercentage() {
      if (this.plan === 0) return 0;
      let result = null;
      if (this.useRawValues) {
        if (this.revertKPI) {
          result = this.factProp !== null
            ? ((1 + this.planProp) / (1 + this.factProp)) * 100
            : 0;
        } else {
          result = (this.factProp / this.planProp) * 100;
        }

      } else {
        result = (this.fact / this.plan) * 100;
      }

      result = _.floor(result, 1);

      return result;
    }
  },
  methods: {
    formatDigit
  }
}
</script>

<style lang="scss">
.kpi-stats {
  display: flex;
  height: 40px;
  width: 100%;
  &__result {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    max-width: 60px;
    width: 100%;
    &-title {
      color: var(--prospace-ui-icon-gray);
      font-size: 10px;
    }
    &-value {
      color: var(--prospace-text-main);
      font-weight: 500;
      font-size: 14px;
      @container (max-width: 1130px) {
        margin-bottom: 5px;
      }
    }
    @container (max-width: 1130px) {
      align-items: flex-start;
    }
  }
  &__diagram {
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    flex-grow: 1;
    @container (max-width: 1130px) {
      height: 33px;
      margin-left: 0;
    }
  }
  &__block {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 50%;
    border-radius: 2px;
    color: var(--prospace-text-white);
    font-weight: 700;
    font-size: 12px;
    max-height: 100%;
    line-height: 14px;
    &--plan {
      background: var(--prospace-chart-plan);
      height: 100%;
    }
    &--fact {
      background: var(--prospace-chart-fact);
      margin-left: 1px;
      min-height: 50%;
      container-type: size;
      &__value {
        @container (max-height: 15px) {
          position: relative;
          display: inline-block;
          width: 100%;
          text-align: center;
          top: -14px;
          color: var(--prospace-text-light-gray);
        }
      }
    }
    &--empty {
      min-height: 2px;
      padding: 0;
      color: var(--prospace-text-light-gray);
    }
  }
}
</style>
